import type { TreeGrid } from '../types';
import type { Enum } from './types';
import { convertEnum } from './utils';

export type CreateCellDefConfig<T extends string> = Omit<TreeGrid.Cell<T>, 'Name' | 'Enum'> & Enum;

export const createCellDef = <T extends string>(
  config: CreateCellDefConfig<T>,
): TreeGrid.CellDef<T> => {
  const { Enum, Type, ...rest } = config;

  return {
    Type,
    ...rest,
    ...convertEnum(Type, Enum),
  };
};
